<div class="exchange-log table-wrapper">
    <aumico-table [options]="options" [data]="data" [delegate]="this"> </aumico-table>
</div>
